import React, { useEffect, useState } from "react";
// reactstrap components
import {
  Card,
  Container,
  CardHeader,
  CardBody,
  Table,
  Row,
  Col,
  Button
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import { connect } from "react-redux";
import Unauthorized from "views/Pages/Unauthorized";
import { GetApiActionWithAuthorization } from "constantFunctions/apiActions";
import AddOrUpdateGiftReceiverModal from "views/Modal/GiftReceiver/AddOrUpdateGiftReceiverModal";
import SendGiftModal from "views/Modal/GiftReceiver/SendGiftModal";
import { toast } from "react-toastify";
import { resetState } from "../../redux/common/commonAction";

function GiftReceivers(props) {
  const [unauthorized, setUnauthorized] = useState(false);
  const [saveModal, setSaveModal] = useState(false);
  const [sendGiftModal, setSendGiftModal] = useState(false);
  const [editData, setEditData] = useState({ id: 0, firstName: "", lastName: "", email: "", phone: "" });
  const [giftReceivers, setGiftReceivers] = useState([]);
  const [filter, setFilter] = useState({
    page: 1,
    pageSize: 50,
    search: "",
  });
  useEffect(() => {
    //loading the default tab data
    loadGiftReceivers();
  }, []);

  if (giftReceivers.error && !unauthorized) {
      if (giftReceivers.error.status === 403) {
        setUnauthorized(true);
      } else if (giftReceivers.error.status === 440) {
        toast.error(giftReceivers.error.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        props.history.push("/auth/login");
      }
  }

  const loadGiftReceivers = (params) => {
    params = Object.assign(filter, params);
    GetApiActionWithAuthorization("gift-receivers/all", filter)
    .then((res) => {
      setGiftReceivers(res.data)
    })
    .catch((err) => {
      if (err.status === 403) {
        setUnauthorized(true);
      } else if (err.status === 440) {
        props.resetState();
        toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
        props.history.push("/auth/login");
      }
    });
  };

  const processDeleteGiftReceiver = (id) => {
    if (window.confirm("Are you sure you want to delete this employee ?")) {
      GetApiActionWithAuthorization(`gift-receivers/delete/${id}`)
      .then((res) => {
        toast.success(res.message, { position: toast.POSITION.TOP_CENTER });
        loadGiftReceivers();
      })
      .catch((err) => {
        if (err.status === 440) {
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
    }
  };

  const toggleSendGift = (item) => {
    setEditData({
      giftReceiverId: item.id,
      id: 0,
      amount: item.amount || "",
      description: item.description || ""
    });
    setSendGiftModal(!sendGiftModal);
  }

  const toggleAdd = () => {
    setSaveModal(!saveModal);
  };

  const toggleEdit = (item) => {
    setEditData(item);
    setSaveModal(!saveModal);
  };

  const renderTableData = (e) => {
    return giftReceivers.map((item, i) => {
      return (
        <tr key={i}>
          <td>
            <a href={`/portal/gift-receivers/gifts-history/?id=${item.id}`}>
              {item.firstName} {item.lastName}
            </a>
          </td>
          <td>{item.email}</td>
          <td>{item.phone}</td>
          <td>${item.totalAmount}</td>
          <td>
            <Button
              size="sm"
              color="warning"
              onClick={() => toggleEdit(item)}
            >
              <i className="fas fa-pencil-alt"></i> Edit
            </Button>
            <Button
              size="sm"
              color="danger"
              onClick={() => processDeleteGiftReceiver(item.id)}
            >
              <i className="fas fa-trash-alt"></i> Delete
            </Button>
            <Button
              size="sm"
              color="primary"
              onClick={() => toggleSendGift(item)}
            >
              <i className="fas fa-hand-holding-usd"></i> Send Gift
            </Button>
          </td>
        </tr>
      );
    });
  };

  return unauthorized ? (
    <Unauthorized />
  ) : (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--9 main-content" fluid>
        <Card className="card-height shadow">
          <CardHeader>
            <div className="text-center">
              <h1>Gift Receivers</h1>
            </div>
          </CardHeader>
          <CardBody>
            <Row className="my-3">
              <Col md="12" className="search-left-btn mb-0">
                <Button
                  id="add-new"
                  color="primary"
                  onClick={toggleAdd}>
                  <i className="fas fa-plus-circle"></i> Add New
                </Button>
                <Button
                  id="send-gift"
                  color="primary"
                  onClick={() => toggleSendGift({
                    id: 0,
                    giftReceiverId: 0,
                    amount: "",
                    description: ""
                  })}>
                  <i className="fas fa-hand-holding-usd"></i> Send Gift
                </Button>
                <a
                  id="category"
                  href="/portal/gift-receivers/gifts-history">
                  <Button color="primary">
                    <i className="fas fa-gifts"></i> Gifts
                  </Button>
                </a>
              </Col>
            </Row>
            <Table className="coin-table border-top-none" responsive bordered>
              <thead className="thead-light">
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">Phone</th>
                  <th scope="col">Total Gift Amount</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>{renderTableData()}</tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>
      {saveModal && (
        <AddOrUpdateGiftReceiverModal
          {...props}
          show={saveModal}
          toggle={editData.id === 0 ? toggleAdd : toggleEdit}
          data={editData}
          refreshData={loadGiftReceivers} />
      )}
      {sendGiftModal && (
        <SendGiftModal
          {...props}
          show={sendGiftModal}
          data={editData}
          giftReceivers={giftReceivers}
          toggle={toggleSendGift} />
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetState: () => dispatch(resetState()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GiftReceivers);
